"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var ServiceFetch_1 = __importDefault(require("../../utilities/ServiceFetch"));
var utilities_1 = require("@ikea-aoa/utilities");
var OversattaTransformer_1 = __importDefault(require("./OversattaTransformer"));
/**
 * This service is used for fetching localization information from ÖVERSÄTTA.
 */
var OversattaService = /** @class */ (function () {
    /**
     * Constructor.
     *
     * @param options Options.
     * @param options.localizationPrefixApplication Localization prefix application.
     * @param options.localizationEndpoints Localization endpoints.
     * @param [options.localizationOverrides] Localization overrides.
     * @param options.locale Locale.
     */
    function OversattaService(options) {
        this.localizationPrefixApplication = null;
        this.localizationEndpoints = null;
        this.localizationOverrides = null;
        this.locale = null;
        this.localizationPrefixApplication = options.localizationPrefixApplication;
        this.localizationEndpoints = options.localizationEndpoints;
        this.localizationOverrides = options.localizationOverrides;
        this.locale = options.locale;
    }
    /**
     * Fetches and returns translations.
     *
     * @returns Promise object.
     */
    OversattaService.prototype.getLocalizedInformation = function () {
        return __awaiter(this, void 0, void 0, function () {
            var responses, transformer, transformed, _i, responses_1, response;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, Promise.all(this.localizationEndpoints.map(function (url) { return _this.fetch(url); }))];
                    case 1:
                        responses = _a.sent();
                        transformer = new OversattaTransformer_1.default({
                            localizationPrefixApplication: this.localizationPrefixApplication,
                            locale: this.locale
                        });
                        transformed = [];
                        for (_i = 0, responses_1 = responses; _i < responses_1.length; _i++) {
                            response = responses_1[_i];
                            transformed.push(transformer.transform(response));
                        }
                        if (this.localizationOverrides) {
                            transformed.push(transformer.transform(this.localizationOverrides));
                        }
                        return [2 /*return*/, this.mergeLocalizedInformation(transformed)];
                }
            });
        });
    };
    /**
     * Merges multiple localized information.
     *
     * @param localizedInformations Array of localized informations.
     * @returns Merged localized informations.
     */
    OversattaService.prototype.mergeLocalizedInformation = function (localizedInformations) {
        var merged = Object.assign.apply(Object, __spreadArrays([{}], localizedInformations));
        var _loop_1 = function (key) {
            merged[key] = Object.assign.apply(Object, __spreadArrays([{}], localizedInformations.map(function (localizedInformation) { return localizedInformation[key]; })));
        };
        for (var _i = 0, _a = Object.keys(merged); _i < _a.length; _i++) {
            var key = _a[_i];
            _loop_1(key);
        }
        return merged;
    };
    /**
     * Fetches and returns translations.
     *
     * @param url URL.
     * @returns Promise object.
     */
    OversattaService.prototype.fetch = function (url) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, country, language, parsedUrl;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = utilities_1.LocaleUtility.getCountryAndLanguage(this.locale), country = _a.country, language = _a.language;
                        parsedUrl = url.replace('{country}', country).replace('{language}', language);
                        return [4 /*yield*/, ServiceFetch_1.default.json(parsedUrl, {
                                credentials: 'same-origin'
                            })];
                    case 1: return [2 /*return*/, _b.sent()];
                }
            });
        });
    };
    return OversattaService;
}());
exports.default = OversattaService;
//# sourceMappingURL=OversattaService.js.map